module.exports = __webpack_public_path__ + "static/media/Location_Book-Page49.b0d0a724.png";